import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRadium, DetectCompact } from 'higher-order-components'
import { FORM_ERRORS } from 'constants/errors'
import { fetchKoalaData } from 'apis/koala'
import { CheckBox } from 'components'
import { get } from 'utils'
import DealerDetails from './dealer-details'


class DealersField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dealers: props.initialLocations || []
    }
  }
  componentDidMount() {
    const { initialLocations } = this.props
    initialLocations.length && this.onChange(initialLocations[0])
  }
  componentWillReceiveProps(newprops) {
    const getPostecode = get('location.value.postcode')
    if (
      getPostecode(newprops) !== getPostecode(this.props) &&
      newprops.location &&
      newprops.location.value
    ) {
      this.fetchDealers(newprops.location.value.postcode)
    }
  }

  onChange = (location) => {
    const { onChange } = this.props
    onChange({
      id: location.id,
      code: location.dealerCode
    })
  }

  fetchDealers = (postcode) => {
    const { endpoint, initialLocations, type } = this.props
    if (initialLocations.length || !postcode) return
    const options = {
      DealerType: type || null,
      PostCode: postcode
    }
    this.setState({
      dealersSpinner: true,
      dealers: null
    })
    fetchKoalaData(endpoint, options)
      .then((dealers) => {
        if (!dealers) return

        this.setState(
          {
            dealers,
            dealersSpinner: false
          },
          () => {
            this.onChange(dealers[0])
          }
        )
      })
      .catch((error) => {
        /**
        * @todo  handle errors here
        */
        console.warn(error)
      })
  }
  render() {
    const {
      value = {}, type, subTitle, gtmEvents
    } = this.props
    const { dealers } = this.state
    return (
      <div style={{ margin: '1em 0' }}>
        {dealers && dealers.length > 0 ? (
          dealers.map(location => (
            <div
              key={location.id}
              style={{
                display: 'flex',
                flexDirection: 'row',
                color: value.id === location.id ? 'black' : undefined
              }}>
              <div style={{ padding: '.25em' }}>
                <CheckBox
                  checked={value.id === location.id}
                  onClick={() => this.onChange(location)} />
              </div>
              <div
                style={{
                  flexGrow: 1,
                  paddingLeft: '2em',
                  lineHeight: 1.2,
                  fontWeight: 300,
                  cursor: 'pointer'
                }}>
                <DealerDetails compact={this.props.compact} gtmEvents={gtmEvents} location={location} type={type} />
              </div>
            </div>
          ))
        ) : (
            <p style={{ textAlign: 'center', fontWeight: 200, lineHeight: 1.6 }}>
              {FORM_ERRORS.DEALERS_NO_POSTCODE}
            </p>
          )}
      </div>
    )
  }
}

DealersField.propTypes = {
  type: PropTypes.oneOf(['service', 'sales', 'parts']),
  endpoint: PropTypes.string.isRequired,
  initialLocations: PropTypes.array,
  value: PropTypes.shape({
    id: PropTypes.string,
    code: PropTypes.string
  }),
  onChange: PropTypes.func,
  gtmEvents: PropTypes.array
}

DealersField.defaultProps = {
  initialLocations: []
}

export default withRadium(DetectCompact())(DealersField)



// WEBPACK FOOTER //
// ./src/components/form-elements/dealers-field/index.jsx